module.exports = __webpack_public_path__ + "static/media/fire-testimonial-1.73930147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/fire-testimonial-1.jpg
// module id = 1181
// module chunks = 0